import {addSeconds} from 'date-fns';
import {
  COMMENT_COOLDOWN_SECONDS,
  LOCAL_STORAGE_COMMENT_COOLDOWN,
} from '../constant';

export function setCommentCooldownLocalStorage(userUid: string) {
  window.localStorage.setItem(
    LOCAL_STORAGE_COMMENT_COOLDOWN,
    JSON.stringify({
      uid: String(userUid),
      expires: String(addSeconds(Date.now(), COMMENT_COOLDOWN_SECONDS)),
    })
  );
}
